<template>
  <Layout>
    <div class="row">
      <div class="row mt-md-n4" v-if="userData.permissions['view_dashboard'] == 1">
        <div class="col-xl-12">
          <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
            <h5><i class="mdi mdi-speedometer"></i> Dashboard</h5>

          </div>
          <div class="row g-2 mb-0 mt-1">
            <div class="col-12 col-md-6 col-xl-3" v-for="card in activeCards" :key="card.key">
              <div class="card shadow-lg dashbord-card h-90" @click="$router.push(card.link)">
                <div class="card-body p-3 d-flex flex-column">
                  <div class="d-flex align-items-start justify-content-between mb-2">
                    <div>
                      <p class="fw-semibold mb-1 text-muted">{{ card.name }}</p>
                      <div class="h2 mb-0">{{ commas(card.primary.value) }}</div>
                      <small class="text-muted">{{ card.primary.label }}</small>
                    </div>
                    <div class="avatar-sm p-2 align-self-center rounded-circle mini-stat-icon bg-primary">
                      <span class="avatar-title"><i :class="card.icon"></i></span>
                    </div>
                  </div>

                  <div class="mt-auto border-top pt-2 d-flex justify-content-between align-items-center gap-3">
                    <span class="small text-muted">{{ card.footer.label }}</span>
                    <span class="fw-semibold">{{ commas(card.footer.value) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-n4 g-3 align-items-stretch">
            <div class="col-12 col-xl-8">
              <div class="card shadow-lg h-100">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <div>
                      <div class="h5 mb-1">Dashboard Trends</div>
                      <div class="text-muted small">Select a tab to switch between the monthly views.</div>
                    </div>
                  </div>

                  <b-tabs pills card content-class="pt-3" class="dashboard-tabs">
                    <b-tab title="Savings & Shares" active>
                      <apexchart class="apex-charts" type="bar" height="340" :options="graphOne.chartOptions"
                        :series="graphOne.series"></apexchart>
                    </b-tab>
                    <b-tab title="Running Loans">
                      <apexchart class="apex-charts" type="line" height="340" :options="graphRunning.chartOptions"
                        :series="graphRunning.series"></apexchart>
                    </b-tab>
                    <b-tab title="Closed Loans">
                      <apexchart class="apex-charts" type="bar" height="340" :options="graphClosed.chartOptions"
                        :series="graphClosed.series"></apexchart>
                    </b-tab>
                    <b-tab title="Expense Trend">
                      <apexchart class="apex-charts" type="line" height="340" :options="graphThree.chartOptions"
                        :series="graphThree.series"></apexchart>
                    </b-tab>
                    <b-tab title="Investments & Returns">
                      <apexchart type="bar" height="340" :options="graphFour.chartOptions" :series="graphFour.series" />
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>

            <div class="col-12 col-xl-4">
              <div class="card shadow-lg h-100 dashboard-pie-card">
                <div class="card-body d-flex flex-column">
                  <div class="text-uppercase small fw-semibold text-muted mb-1">Financial Position</div>
                  <div class="h5 mb-2">Current Savings vs Running Loans</div>
                  <apexchart class="apex-charts flex-grow-1" type="donut" height="340"
                    :options="savingsLoansPie.chartOptions" :series="savingsLoansPie.series"></apexchart>
                  <div v-if="runningLoans > currentSavings" class="alert alert-danger py-2 px-3 small mb-0 mt-2">
                    Running loans are higher than current savings.
                  </div>
                  <div v-else class="alert alert-success py-2 px-3 small mb-0 mt-2">
                    Savings are ahead of running loans.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="row justify-content-center">
          <div class="col-md-8 col-xl-6">
            <div>
              <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
              <center><span class="text-primary h6">You have no permission to view dashboard items</span></center>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="updates" size="lg" hide-footer hide-header centered no-close-on-backdrop no-close-on-esc
      body-class="p-0 rounded">
      <div class="position-relative">
        <!-- Image Slider Container -->
        <div
          class="update-slider-container bg-light text-center d-flex align-items-center justify-content-center overflow-hidden"
          style="min-height: 400px; border-radius: 8px 8px 0 0;">
          <transition name="fade" mode="out-in">
            <div :key="update_number" class="w-100">
              <img v-if="update_number == 1" src="@/assets/images/updates/new_tandika/slide_1.webp" alt="Update 1"
                class="img-fluid w-100">
              <img v-if="update_number == 2" src="@/assets/images/updates/new_tandika/slide_2.webp" alt="Update 2"
                class="img-fluid w-100">
              <img v-if="update_number == 3" src="@/assets/images/updates/new_tandika/slide_3.webp" alt="Update 3"
                class="img-fluid w-100">
              <img v-if="update_number == 4" src="@/assets/images/updates/new_tandika/slide_4.webp" alt="Update 4"
                class="img-fluid w-100">
              <img v-if="update_number == 5" src="@/assets/images/updates/new_tandika/slide_5.webp" alt="Update 5"
                class="img-fluid w-100">
              <img v-if="update_number == 6" src="@/assets/images/updates/new_tandika/slide_6.webp" alt="Update 6"
                class="img-fluid w-100">
              <img v-if="update_number == 7" src="@/assets/images/updates/new_tandika/slide_7.webp" alt="Update 7"
                class="img-fluid w-100">
              <img v-if="update_number == 8" src="@/assets/images/updates/new_tandika/slide_8.webp" alt="Update 8"
                class="img-fluid w-100">
              <img v-if="update_number == 9" src="@/assets/images/updates/new_tandika/slide_9.webp" alt="Update 9"
                class="img-fluid w-100">
            </div>
          </transition>
        </div>

        <!-- Navigation and Progress -->
        <div class="p-4 bg-white" style="border-radius: 0 0 8px 8px;">
          <div class="text-center mb-4">
            <h5 class="fw-bold text-primary mb-1">What's New in Tandika</h5>
            <p class="text-muted small mb-0">Slide {{ update_number }} of {{ update_total }}</p>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <!-- Previous Button -->
            <button :disabled="update_number == 1" @click.prevent="previousUpdate"
              class="btn btn-light px-4 rounded-pill fw-semibold"
              :style="{ visibility: update_number == 1 ? 'hidden' : 'visible' }">
              &larr; Previous
            </button>

            <!-- Dot Indicators -->
            <div class="d-flex gap-2">
              <span v-for="n in update_total" :key="n" class="rounded-circle"
                :class="n === update_number ? 'bg-primary' : 'bg-light'"
                style="width: 10px; height: 10px; display: inline-block; transition: background-color 0.3s ease;">
              </span>
            </div>

            <!-- Next / Got It Buttons -->
            <button v-if="update_number < update_total" @click.prevent="nextUpdate"
              class="btn btn-primary px-4 rounded-pill fw-semibold shadow-sm">
              Next &rarr;
            </button>

            <button v-else @click.prevent="seenUpdates" class="btn btn-success px-4 rounded-pill fw-bold shadow">
              Got it! &#10003;
            </button>
          </div>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import {
  memberMethods, memberComputed, savingMethods, savingComputed,
  shareMethods, shareComputed, withdrawMethods, withdrawComputed,
  runningloanMethods, runningloanComputed, loandisbursementMethods, loandisbursementComputed
} from "@/state/helpers";
import { financialyearComputed } from "@/state/helpers";

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      active_branch: localStorage.getItem('active_branch'),
      financialYear: JSON.parse(localStorage.getItem("financialyear")),
      activeFinancialYear: JSON.parse(localStorage.getItem("financialyear")),
      activeFinancialYearLabel: "",
      viewingActiveFinancialYear: true,
      month: "", year: "",
      arrow_direction: false,
      financial_years: [],
      dashboardMembers: 0,
      dashboardSavings: 0,
      dashboardWithdraws: 0,
      currentSavings: 0,
      withdrawcharges: 0,
      dashboardShares: 0,
      capital: 0,
      loans: 0,
      loanstaken: 0,
      loanspaid: 0,
      runningLoans: 0,
      loanPayments: 0,
      interest: 0,
      arrears: 0,
      returns: 0,
      expenses: 0,
      membershipfees: 0,
      registrationfees: 0,
      contributions: 0,
      giveaways: 0,
      dividendpayouts: 0,
      interestpayouts: 0,
      investments: 0,
      expenseCategoriesCount: 0,
      expenseItemsCount: 0,
      yearlyloans: [],
      yearlysavings: [],
      yearlyactivity: [],
      yearlypayouts: [],
      loader: false,
      update_number: 1,
      update_total: 9,

      cashflow: {
        series: [],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          colors: ['#088588', '#DC143C', '#0096FF', '#f1b44c'],
          dataLabels: { enabled: false },
          stroke: { curve: 'smooth', width: 2 },
          xaxis: { categories: [] },
        },
      },
      incomeBreakdown: {
        series: [],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          labels: [],
          legend: { position: 'bottom' },
        },
      },
      outflowBreakdown: {
        series: [],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          labels: [],
          legend: { position: 'bottom' },
        },
      },
      
      graphOne: {
        series: [
          { name: 'Savings', data: [] },
          { name: 'Shares', data: [] },
          { name: 'Withdraws', data: [] },
        ],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          chart: { toolbar: { show: false } },
          colors: ['#088588', '#0096FF', '#f46a6a'],
          dataLabels: { enabled: false },
          plotOptions: { bar: { columnWidth: '50%' } },
          stroke: { width: 0 },
          xaxis: { categories: [] },
          legend: { position: 'bottom' },
        },
      },
      graphRunning: {
        series: [
          { name: 'Running Loans', data: [] },
          { name: 'Expected Interest', data: [] },
          { name: 'Payments Made', data: [] },
        ],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          chart: { toolbar: { show: false } },
          colors: ['#0262a7', '#f1b44c', '#f46a6a'],
          dataLabels: { enabled: false },
          stroke: { curve: 'smooth', width: 3 },
          xaxis: { categories: [] },
          legend: { position: 'bottom' },
        },
      },
      graphClosed: {
        series: [
          { name: 'Closed Loans', data: [] },
          { name: 'Interest & Fines', data: [] },
        ],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          chart: { toolbar: { show: false } },
          colors: ['#088588', '#f46a6a'],
          dataLabels: { enabled: false },
          plotOptions: { bar: { columnWidth: '50%' } },
          stroke: { width: 0 },
          xaxis: { categories: [] },
          legend: { position: 'bottom' },
        },
      },
      graphThree: {
        series: [{ name: 'Expense Details', data: [] }],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          chart: { toolbar: { show: false } },
          colors: ['#f46a6a'],
          dataLabels: { enabled: false },
          stroke: { curve: 'smooth', width: 3 },
          xaxis: { categories: [] },
          legend: { position: 'bottom' },
        },
      },
      graphFour: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 3,
          },
          xaxis: {
            categories: []
          },
          legend: {
            position: 'bottom',
          },
          noData: {
            text: 'No investment data'
          }
        }
      },
      savingsLoansPie: {
        series: [0, 0],
        chartOptions: {
          noData: { text: 'Please Wait...' },
          labels: ['Current Savings', 'Running Loans'],
          colors: ['#088588', '#f46a6a'],
          legend: { position: 'bottom' },
          dataLabels: { formatter: (val) => `${Math.round(val)}%` },
        },
      },
      card_hover: false,
      card_number: '',
    };
  },
  async mounted() {
    await this.dashboardanalysis();
    await this.refreshUserData();
    if (this.userData.viewed_updates == 0) {
      if (!localStorage.getItem('reloadOnce')) {
        localStorage.setItem('reloadOnce', 'true');
        window.location.reload();
      } else {
        localStorage.removeItem('reloadOnce');
        this.$bvModal.show('updates');
      }
    }
  },
  computed: {
    ...memberComputed,
    ...savingComputed,
    ...shareComputed,
    ...withdrawComputed,
    ...runningloanComputed,
    ...loandisbursementComputed,
    ...financialyearComputed,
    arrowDirection() {
      return this.arrow_direction;
    },
    financialYearLabel() {
      if (this.financialYear && this.financialYear.start && this.financialYear.end) {
        return `${this.formatDate(this.financialYear.start)} - ${this.formatDate(this.financialYear.end)}`;
      }
      return this.activeFinancialYearLabel || 'Active Financial Year';
    },
    activeCards() {
      const permissions = this.userData && this.userData.permissions ? this.userData.permissions : {};

      return [
        {
          key: 'members',
          name: 'Members',
          icon: 'mdi mdi-account-multiple',
          link: '/view-members',
          visible: permissions.view_members == 1,
          primary: { label: 'Total members', value: this.dashboardMembers },
          footer: { label: 'Membership fees paid', value: this.membershipfees },
        },
        {
          key: 'savings',
          name: 'Current Savings',
          icon: 'mdi mdi-google-circles-group',
          link: '/savings',
          visible: permissions.view_savings == 1 || permissions.view_withdraws == 1,
          primary: { label: 'Total Savings - withdraws', value: this.currentSavings },
          footer: { label: 'Total withdraws taken out', value: this.dashboardWithdraws },
        },
        {
          key: 'loans',
          name: 'Running Loans',
          icon: 'mdi mdi-cash-multiple',
          link: '/running-loans',
          visible: permissions.view_runningloans == 1 || permissions.view_closedloans == 1 || permissions.view_loans == 1,
          primary: { label: 'Running loan principal', value: this.runningLoans },
          footer: { label: 'Loan payments made', value: this.loanPayments },
        },
        {
          key: 'expenses',
          name: 'Expenses',
          icon: 'mdi mdi-receipt',
          link: '/view-expenses',
          visible: permissions.view_expenses == 1 || permissions.view_dashboard == 1,
          primary: { label: 'Spent in Financial Year', value: this.expenses },
          footer: { label: 'Expense items', value: this.expenseItemsCount },
        },
      ].filter(card => card.visible);
    }
  },
  watch: {
    currentFinancialYear(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.loadDashboard(newValue);
      }
    },
  },
  methods: {
    ...memberMethods,
    ...savingMethods,
    ...shareMethods,
    ...withdrawMethods,
    ...runningloanMethods,
    ...loandisbursementMethods,
    commas(x) { return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0'; },

    formatDate(date) {
      let d = new Date(date);
      let month = d.toLocaleString('default', { month: 'long' });
      let year = d.getFullYear();
      return [month, year].join(' ');
    },

    async refreshUserData() {
      await axios.get('/user').then((response) => {
        this.userData = response.data.user;
        localStorage.setItem("user", JSON.stringify(this.userData));
      });
    },

    seenUpdates() {
      const obj = {
        member_id: this.userData.member.member_id
      }
      axios.post('viewed-updates', obj)
      this.$bvModal.hide('updates');
      this.userData.viewed_updates = 1;
      localStorage.setItem("user", JSON.stringify(this.userData));
    },

    toggleArrowDirection() {
      this.arrow_direction = !this.arrow_direction;
    },

    async selectFinancialYear(id) {
      await this.$store.dispatch('financialyears/fetchSetFinancialYearData', id);
      await this.$router.replace({ query: { ...this.$route.query, fyear: id } });
      localStorage.setItem('selected_fyear', String(id));
      const storeFyear = this.$store.getters['financialyears/currentFinancialYear'] || id;
      await this.loadDashboard(storeFyear);
    },

    async resetToActiveFinancialYear() {
      if (this.activeFinancialYear) {
        const query = { ...this.$route.query };
        delete query.fyear;
        await this.$router.replace({ query });
        localStorage.removeItem('selected_fyear');
        await this.$store.dispatch('financialyears/fetchSetFinancialYearData', this.activeFinancialYear.id);
        localStorage.setItem("financialyear", JSON.stringify(this.activeFinancialYear));
        const storeFyear = this.$store.getters['financialyears/currentFinancialYear'] || this.activeFinancialYear.id;
        await this.loadDashboard(storeFyear);
      }
    },

    async dashboardanalysis() {
      const queryYear = this.$route.query.fyear ? Number(this.$route.query.fyear) : null;
      const storeYear = this.$store.getters['financialyears/currentFinancialYear'] || null;
      const requestedYear = queryYear !== null ? queryYear : storeYear;
      await this.loadDashboard(requestedYear);
    },

    async loadDashboard(fyear = null) {
      this.loader = true;
      const storeYear = this.$store.getters['financialyears/currentFinancialYear'] || null;
      const finalYear = fyear !== null ? fyear : storeYear;
      let payload = finalYear ? { fyear: finalYear } : {};

      try {
        let [summary, graphics] = await Promise.all([
          axios.post('/dashboardanalysis', payload),
          this.graphicalanalysis(finalYear)
        ]);

        this.applyDashboardSummary(summary.data);
        this.applyDashboardCharts(graphics.data);
        this.fetchLoanDisbursements();
        this.fetchRunningLoans();
      } finally {
        this.loader = false;
      }
    },

    permission(key) {
      return this.userData && this.userData.permissions && this.userData.permissions[key] == 1;
    },

    applyDashboardSummary(data) {
      this.financialYear = data.financial_year || this.financialYear;
      this.activeFinancialYear = data.active_financial_year || this.activeFinancialYear;
      this.activeFinancialYearLabel = data.active_financial_year_label || "";
      this.viewingActiveFinancialYear = data.viewing_active_financial_year;
      this.dashboardMembers = data.members;
      this.dashboardSavings = data.savings;
      this.dashboardWithdraws = data.withdraws;
      this.currentSavings = data.current_savings || 0;
      this.withdrawcharges = data.withdrawcharges;
      this.dashboardShares = data.shares;
      this.capital = data.capital;
      this.loans = data.loans;
      this.loanstaken = data.loanstaken;
      this.loanspaid = data.loanspaid;
      this.runningLoans = data.running_loans || 0;
      this.loanPayments = data.loan_payments || 0;
      this.interest = data.interest;
      this.arrears = data.arrears;
      this.returns = data.returns;
      this.expenses = data.expenses;
      this.membershipfees = data.membershipfees;
      this.registrationfees = data.registrationfees;
      this.contributions = data.contributions;
      this.giveaways = data.giveaways;
      this.dividendpayouts = data.dividendpayouts;
      this.interestpayouts = data.interestpayouts;
      this.investments = data.investments;
      this.expenseCategoriesCount = data.expense_categories_count || 0;
      this.expenseItemsCount = data.expense_items_count || data.expense_categories_count || 0;
    },

    async graphicalanalysis(fyear = null) {
      let url = "/graphicalanalysis";
      return axios.get(url, { params: fyear ? { fyear } : {} });
    },

    applyDashboardCharts(data) {
      let months = data.months || [];
      let savings = data.savings || [];
      let shares = data.shares || [];
      let withdraws = data.withdraws || [];
      let expenses = data.expenses || [];
      let expenseTrend = data.expense_trend || { months: [], series: [{ name: 'Expense Details', data: [] }] };
      let investmentTrend = data.investments || data.investment_trend || { months: [], series: [] };
      let normalizedInvestmentSeries = Array.isArray(investmentTrend.series)
        ? investmentTrend.series
          .filter(series => series && Array.isArray(series.data))
          .map(series => ({
            ...series,
            data: series.data.map(value => Number(value) || 0),
          }))
        : [];

      this.graphOne.chartOptions = {
        ...this.graphOne.chartOptions,
        xaxis: { categories: months },
      };
      this.graphOne.series = [
        { name: 'Savings', data: savings },
        { name: 'Shares', data: shares },
        { name: 'Withdraws', data: withdraws },
      ];

      this.graphRunning.chartOptions = {
        ...this.graphRunning.chartOptions,
        xaxis: { categories: months },
      };
      this.graphRunning.series = [
        { name: 'Running Loans', data: data.running_loans || [] },
        { name: 'Expected Interest', data: data.running_interest || [] },
        { name: 'Payments Made', data: data.loan_payments || [] },
      ];

      this.graphClosed.chartOptions = {
        ...this.graphClosed.chartOptions,
        xaxis: { categories: months },
      };
      this.graphClosed.series = [
        { name: 'Closed Loans', data: data.closed_loans || [] },
        { name: 'Interest & Fines', data: data.closed_interest_fines || [] },
      ];

      this.graphThree.chartOptions = {
        ...this.graphThree.chartOptions,
        xaxis: { categories: expenseTrend.months || months },
      };
      this.graphThree.series = expenseTrend.series && expenseTrend.series.length ? expenseTrend.series : [{ name: 'Expense Details', data: expenses }];

      this.graphFour.chartOptions = {
        ...this.graphFour.chartOptions,
        xaxis: {
          categories: investmentTrend.months || months,
        }
      };

      this.graphFour.series = normalizedInvestmentSeries;

      this.savingsLoansPie.series = [
        Math.max(Number(this.currentSavings) || 0, 0),
        Math.max(Number(this.runningLoans) || 0, 0),
      ];
    },

    nextUpdate() {
      if (this.update_number < this.update_total) {
        this.update_number += 1;
      }
    },

    previousUpdate() {
      if (this.update_number > 1) {
        this.update_number -= 1;
      }
    },
  },
};
</script>

<style>
.dashbord-card {
  cursor: pointer
}

/* Add to existing <style> block */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.update-slider-container {
  box-shadow: inset 0 -4px 10px rgba(0, 0, 0, 0.05);
}
</style>